import Immutable from 'immutable';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
  Submittal,
  SubmittalListTypes,
  SubmittalOrderedMap,
} from 'records/Submittal';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import ApprovedFiles from './ApprovedFiles';
import ApprovedSubHeader from './ApprovedSubHeader';
import ApprovedSubmittalFolders from './ApprovedSubmittalFolders';
import { ApprovedFileSortFields } from './SortButton';

interface State {
  selectedSpecSection: string; // two digit number as string.
  selectedSpecNumber: string;
  search: string;
  sortDirection: 'ascending' | 'descending';
  sortField: ApprovedFileSortFields;
  downloadedFiles: boolean;
}

interface Props extends WithAppStoreProps, RouteComponentProps {}

class ApprovedTab extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const queryParams = new URLSearchParams(props.location.search);
    const specNumberQueryParam = queryParams.get('specnumber');

    this.state = {
      selectedSpecSection: 'all',
      selectedSpecNumber: specNumberQueryParam || '',
      search: '',
      sortDirection: 'ascending',
      sortField: 'dateapproved',
      downloadedFiles: true,
    };

    this.loadSubmittals();
  }

  loadSubmittals = async (): Promise<void> => {
    await this.props.actions.initSubmittalQuery();
    await this.props.actions.getSubmittals(SubmittalListTypes.APPROVED);
    await this.props.actions.querySubmittals();
  };

  updateDownloadingState = (s: boolean): void => {
    this.setState({ downloadedFiles: s });
  };

  handleCheckAllClick = (): void => {
    const { appState, actions } = this.props;
    const { submittals, selectedSubmittals } = appState;

    const updatedSelectedSubmittals =
      selectedSubmittals.size > 0
        ? selectedSubmittals.clear()
        : submittals.keySeq().toSet();

    actions.setSelectedSubmittals(updatedSelectedSubmittals);
  };

  handleSelectSpecNumber = (selectedSpecNumber: string) => {
    const { history, location } = this.props;
    const nextLocation = {
      ...location,
      search: `specnumber=${selectedSpecNumber}`,
    };

    history.replace(nextLocation);

    this.setState({ selectedSpecNumber });
  };

  handleSpecSectionChange = (nextSpecSection: string) => {
    this.setState({ selectedSpecSection: nextSpecSection });
  };

  handleSearchChange = (search: string) => {
    this.setState({ search });
  };

  handleSortChange = (
    field: ApprovedFileSortFields,
    direction: 'ascending' | 'descending'
  ) => {
    this.setState({
      sortDirection: direction,
      sortField: field,
    });
  };

  render(): React.ReactNode {
    const {
      selectedSpecNumber,
      selectedSpecSection,
      search,
      sortDirection,
      sortField,
      downloadedFiles,
    } = this.state;
    const { appState } = this.props;
    const { submittals } = appState;

    // Submittals that exist in the queriedSubmittals list.

    // const approvedSubmittals = qSubmittals.filter(
    const approvedSubmittals = submittals.filter(
      (s: Submittal): boolean => s.status.kind === 'SUB_APPROVED'
    );

    const subsBySpecNumber = approvedSubmittals
      .groupBy((s) => s.specsectionnumber)
      .filter((a, k) => {
        if (selectedSpecSection === 'all') {
          return true;
        }

        return k.slice(0, 2) === selectedSpecSection;
      })
      .toOrderedMap() as Immutable.OrderedMap<string, SubmittalOrderedMap>;

    return (
      <>
        <div className="column grow-1">
          <ApprovedSubHeader
            approvedSubmittals={approvedSubmittals}
            approvedSubmittalGroups={subsBySpecNumber}
            onSpecSectionChange={this.handleSpecSectionChange}
            selectedSpecSection={selectedSpecSection}
            selectedSpecNumber={selectedSpecNumber}
            onSearchChange={this.handleSearchChange}
            onSortChange={this.handleSortChange}
            sortDirection={sortDirection}
            sortField={sortField}
            handleDownloadingState={this.updateDownloadingState}
          />
          <div
            className="row mx4 mb4 h100"
            style={{
              display: 'grid',
              gridGap: '1.5rem',
              gridTemplateRows: '1fr',
              gridTemplateColumns: '336px 1fr',
            }}
          >
            <div style={{ height: 'calc(100vh - 185px)' }}>
              <ApprovedSubmittalFolders
                selectedSpecNumber={selectedSpecNumber}
                approvedSubmittalGroups={subsBySpecNumber}
                onSelectSpecNumber={this.handleSelectSpecNumber}
              />
            </div>

            <div style={{ height: 'calc(100vh - 185px)' }}>
              <ApprovedFiles
                key={selectedSpecNumber || 'empty'}
                specNumber={selectedSpecNumber}
                subsBySpecNumber={subsBySpecNumber}
                search={search}
                sortDirection={sortDirection}
                sortField={sortField}
                filesAreDownloaded={downloadedFiles}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withAppStore(ApprovedTab);
